
import { Component, Vue, Prop } from "vue-property-decorator";
import CaseItem from "./components/CaseItem.vue";
import { getCaseList } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getItemListJsonLd, injectJsonLd } from "@/utils/seo";
@Component({
  components: {
    CaseItem,
    Pagination,
    Breadcrumb
  }
})
export default class Case extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "客户案例 | 企业成功案例与陪跑实践 - 光华赋能",
      description:
        "光华赋能客户成功案例，覆盖制造业、服务业、互联网、零售等多个行业，展示企业在科学经营、管理提升、数字化转型等方面的陪跑实践与成果。",
      keywords:
        "客户案例,成功案例,企业案例,管理咨询案例,培训案例,企业陪跑,光华赋能",
      path: "/case",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "关于光华" },
        { name: "客户案例" }
      ]
    });
  }

  total = 1;
  page = 1;
  per_page = 12;
  list: any = [];
  index: any = 0;
  List = [{ title: "客户案例", url: "" }];
  created() {
    if (this.$route.query.index) {
      this.index = this.$route.query.index;
    }
    this.caseList();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.caseList();
  }
  async caseList() {
    const { data, total } = await getCaseList({
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;
    this.list.map((item: any) => {
      item.thumb_url = item.thumb_url
        ? item.thumb_url
        : "/gh_website/img-default.png";
    });
    this.total = total;
    // 注入 ItemList JSON-LD（案例列表）
    if (data && data.length > 0) {
      injectJsonLd(
        "jsonld-case-list",
        getItemListJsonLd(
          data.map((item: any) => ({
            name: item.title,
            url: `/case-detail/${item.case_id}`,
            image: item.thumb_url ? item.thumb_url : undefined
          }))
        )
      );
    }
    // if (this.index > 0) {
    //   this.$nextTick(() => {
    //     window.location.hash = "#li" + this.index;
    //   });
    // }
  }
  clickCase(item: any) {
    this.$router.push(`/case-detail/${item.case_id}?page=${this.page}`);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
